import React from 'react'
import {
  SummarySaleDetailAcceptProps,
  SummarySaleDetailProps,
} from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/interface'

const withSummarySaleDetail = (Component: React.FC<SummarySaleDetailProps>) => {
  function WithSummarySaleDetail({
    dateSelected,
  }: SummarySaleDetailAcceptProps) {
    const newProps = { dateSelected }
    return <Component {...newProps} />
  }
  return WithSummarySaleDetail
}

export default withSummarySaleDetail
